import Loader from 'components/Loader';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import { useParams } from 'react-router-dom';
import { useGetTimecardByIdQuery } from 'store/api/timecards';
import TimecardEntityView from './TimecardEntityView';
import TimecardRecord from './TimecardRecord';

const TimecardPage = (): JSX.Element => {
    const { id: timecardId } = useParams();
    const isNew = useIsNewDesign();
    const {
        data: timecard,
        currentData,
        isFetching,
    } = useGetTimecardByIdQuery(parseInt(timecardId || '0'), {
        skip: timecardId === undefined,
    });

    // The new design keeps the record on screen while it refetches: a section saving refetches it, and must stay
    // mounted until it is saved.
    if (isNew) {
        return currentData === undefined ? <Loader /> : <TimecardRecord timecard={currentData} />;
    }

    if (timecard === undefined || isFetching) {
        return <Loader />;
    }

    return <TimecardEntityView timecard={timecard} />;
};

export default TimecardPage;
